<template>
	<div class="empty-container">
		<span class="empty-container__title">
			{{ title }}
		</span>
	</div>
</template>

<script>
export default {
	name: 'NewsFeedEmpty',
	props: {
		title: {
			type: String,
			default: 'Empty',
		},
	},
}
</script>

<style lang="scss">
.empty-container {
	width: 100%;
	height: 536px;
	display: flex;
	justify-content: center;
	align-items: center;
	&__title {
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		text-align: center;
		color: #4a4a4a;
	}
}
</style>
